import React, { useState } from 'react';
import { useContent } from '../ContentContext';
const Solutions = () => {
  const [showVideo, setShowVideo] = useState(false);
  const { publishedContent, isLoading } = useContent();

  const toggleVideo = () => {
    setShowVideo(!showVideo);
  };
  // Function to safely render HTML content
  const createMarkup = (html) => {
    return { __html: html };
  };
  return (
    <div className="relative bg-white">
      {/* Content */}
      <div className="relative z-10 px-4 md:px-24 pb-10 md:pt-5 pt-1">
        {/* Heading */}
        <div className="mt-2 md:mt-2 md:mb-5 flex justify-between items-center p mb-2">
          <h1 className="text-[12px] md:text-[36px] font-bold text-[#979797] md:mb-3">
            SMART FARMING |<span className='text-[#152C24]'> FOOD SECURITY</span>
          </h1>
          <div>
            <div className='flex md:gap-2 gap-1 justify-center md:mt-2'>
              <div className='bg-[#CFD7D7] w-[15px] h-[15px] md:w-[40px] md:h-[40px] flex justify-center md:mt-0 rounded-full'> 
                <img
                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1751045210/Expand_left_light_scmuqw.png"
                  alt="Arrow"
                  className="md:w-6 md:h-6 w-3 h-3 mt-2 md:flex hidden"
                />
                <img
                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1751045210/Expand_left_light_scmuqw.png"
                  alt="Arrow"
                  className="w-2 h-2 mt-1 md:hidden flex"
                /> 
              </div>
              <div className="bg-[#2E453D] border-b-[3px] border-[#FFBD26] md:ml-0 ml-2 text-white font-normal md:px-6 px-2 rounded-md md:rounded-[30px] w-[70px] h-[15px] md:w-[150px] md:text-[20px] text-[6px] md:h-[40px] mt-0 md:-mt-[1px] flex justify-between items-center">
                See More
              </div>
              <div className='bg-[#2E453D] w-[15px] h-[15px] md:w-[40px] md:h-[40px] flex justify-center md:mt-0 mr-2 rounded-full'> 
                <img
                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1748783006/Expand_right_gzn0vr.png"
                  alt="Arrow"
                  className="md:w-6 md:h-6 w-3 h-3 mt-2 md:flex hidden"
                />
                <img
                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1748783006/Expand_right_gzn0vr.png"
                  alt="Arrow"
                  className="w-2 h-2 mt-1 md:hidden flex"
                /> 
              </div>
            </div>
          </div>
        </div>

        {/* Video/Image Container */}
        <div className="rounded-md w-full md:h-[630px] h-[175px] relative flex items-center justify-center p-2 md:p-0 pt-2 mt-4">
  <div 
    className="rounded-xl overflow-hidden relative w-full h-[300px] md:mt-5 md:h-[700px] flex justify-center items-center cursor-pointer"
    onClick={toggleVideo}
  >
    {isLoading ? (
      <div className="w-full h-full flex items-center justify-center bg-gray-200 animate-pulse">
        <div className="w-10 h-10 border-4 border-[#FDBD26] border-t-transparent rounded-full animate-spin"></div>
      </div>
    ) : showVideo && publishedContent.isVideo ? (
      <video 
        controls 
        autoPlay 
        className="w-full h-full object-cover"
      >
        <source 
          src={publishedContent.video} 
          type="video/mp4" 
        />
        Your browser does not support the video tag.
      </video>
    ) : (
      <>
        <img
          src={publishedContent.image}
          alt="Banner"
          className="object-cover w-full h-full"
        />
        {publishedContent.isVideo && !isLoading && (
          <div className="absolute inset-0 flex items-center justify-center">
            <img
              src="https://res.cloudinary.com/dzngpgki4/image/upload/v1743776596/image_1502_utmsek.png"
              alt="Play Icon"
              className="w-[50px] h-[50px] md:w-[130px] md:h-[130px] object-contain cursor-pointer hover:scale-110 transition-transform"
            />
          </div>
        )}
      </>
    )}
  </div>
</div>


<div className='md:text-[32px] text-[10px] font-normal md:mt-16 mt-2'>
  <h1 className="text-[12px] md:text-[36px] font-bold md:mb-3">
    <span className='text-[#152C24]'>{publishedContent.title}</span>
  </h1>

  <div>
  <div 
            className="md:text-[32px] text-[8px] whitespace-pre-wrap"
            dangerouslySetInnerHTML={createMarkup(publishedContent.body)}
          />

  </div>
</div>
    
        <div className='md:h-10 h-5'></div>
      </div>
    </div>
  );
};

export default Solutions;
